<template lang="pug">
  .bg
    .wrapper
      section.col1
        HeaderSocial
      section.col2
        Logo(:brand="config.site")
      section.col3
        HeaderDigitalPaper
    .container-navigation
      .wrapper-navigation
        Navigation
</template>
<script>
import { mapState } from 'vuex'

import Navigation from '@/components/Navigation'
import Logo from '@/components/Logo'
import HeaderDigitalPaper from '@/components/HeaderDigitalPaper'
import HeaderSocial from '@/components/HeaderSocial'

export default {
  components: {
    Navigation,
    Logo,
    HeaderDigitalPaper,
    HeaderSocial
  },
  computed: mapState([
    'menu',
    'config'
  ])
}
</script>
<style lang="scss" scoped>
  .bg{
    background-color: white;
    padding-top: 25px;
    border-bottom: 1px solid #dedede;
  }
  .wrapper{
    margin: 0 auto;
    max-width: 1170px;
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: 400px auto 400px;
    align-items: flex-end;
  }

  .container-navigation{
    border-top: 1px solid #dedede;
  }
  .wrapper-navigation{
    margin: 0 auto;
    max-width: 1170px;
    padding: 20px 0;
  }
  .col2{
    padding-bottom: 20px;
  }
</style>

